import { SocialMediaPlatform } from "@/store/types/resizeSettings";
import { bulkResizeSlice } from "../../slice";
import { BulkResizeState } from "../../types";

interface IPayload {
    payload: SocialMediaPlatform;
}

export const setSocialMediaPlatform = (state: BulkResizeState, { payload: platform }: IPayload) => {
    state.resizeSettings.bySocialMedia.platform = platform;

    bulkResizeSlice.caseReducers.setUnit(state, { payload: "pixels" });
    bulkResizeSlice.caseReducers.setWidth(state, {
        payload: state.resizeSettings.bySocialMedia.platform.preset.dimension.width,
    });
    bulkResizeSlice.caseReducers.setHeight(state, {
        payload: state.resizeSettings.bySocialMedia.platform.preset.dimension.height,
    });
};
